import { axiosInstance } from '../common/api';


export const getAllFilteredAssets = (params={}) => {
  const url = `/assets?keyword=${params.keyword}&sortBy=${params.sortBy}&sortOrder=${params.sortOrder}&page=${params.page}&limit=${params.limit}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}

export const getAssetById = (id) => {
  const url = `/assets/${id}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}
export const deleteAsset=(id)=>{
  const url = `/assets/${id}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .delete(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}
export const getUsers = () => {
  const url = '/user/all';
  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}
export const getAllAssets =()=>{
  const url = '/assets';
  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
}
export const createAsset = (assetData) => {
  const url = '/assets';
  return new Promise((resolve, reject) => {
    axiosInstance
      .post(url, assetData)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};
export const updateAsset = (id, assetData) => {
  const url = `/assets/${id}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .put(url, assetData)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};